// Aurelion Sol — Starsurge: after charging for several turns, Aurelion Sol
// unleashes a massive star that stuns all enemies. The star grows more
// powerful with each cast.

import { magicDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const aurelionStarfire: Ability = {
  id: "aurelionStarfire",
  displayName: "Starsurge",
  description: "Hurls a star at all enemies for 0.45× AP + 18 magic damage and stuns for 1 turn. Star grows +18 per previous cast.",
  iconId: "AurelionSolQ",

  targetShape({ caster, combat }) {
    const enemyTeam = caster.team === "player" ? "enemy" : "player";
    return combat.livingUnitsOf(enemyTeam).map(e => e.pos);
  },

  computeHits({ caster, combat }): AbilityHit[] {
    const enemyTeam = caster.team === "player" ? "enemy" : "player";
    const enemies = combat.livingUnitsOf(enemyTeam);
    const stats = effectiveStats(caster);
    const starPower = caster.passiveStacks * 18;
    const dmg = magicDamage(stats.ap * 0.45 + 18 + starPower);

    // Star grows after each cast
    caster.passiveStacks += 1;

    return enemies.map(e => ({
      target: e,
      amount: dmg,
      type: "magical" as const,
      effect: { kind: "stun" as const, duration: 1 },
    }));
  },
};
